import { MeterBarChartConsumerConfig } from '../types/meter-bar-chart-config.js';

// TODO duplication - use type guards?
export const deserializeConfig = (
  serializedConfig: string,
): MeterBarChartConsumerConfig => {
  try {
    return JSON.parse(serializedConfig);
  } catch {
    return {};
  }
};
